import { SnackbarProvider } from 'notistack';
import React from 'react';

export const notistackRef = React.createRef<SnackbarProvider>();
